import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReviewResponse } from "../../../types/reviewTypes";
import { mergePage, Page, PageInfo, pageInfoOf } from "../../../utils/pagination";

interface ReviewState {
  reviewsByProvider: Record<number, ReviewResponse[]>;
  pageInfoByProvider: Record<number, PageInfo>;
  loading: boolean;
  error: string | null;
}

const initialState: ReviewState = {
  reviewsByProvider: {},
  pageInfoByProvider: {},
  loading: false,
  error: null,
};

const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    endLoading(state) {
      state.loading = false;
    },
    setReviewsPage(
      state,
      action: PayloadAction<{ providerId: number; page: Page<ReviewResponse> }>
    ) {
      const { providerId, page } = action.payload;
      state.reviewsByProvider[providerId] = mergePage(state.reviewsByProvider[providerId] || [], page);
      state.pageInfoByProvider[providerId] = pageInfoOf(page);
      state.loading = false;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const reviewActions = reviewSlice.actions;
export default reviewSlice;
